/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmployeeDto } from '../../models/employee-dto';

export interface EmployeeControllerUpdate$Params {
      body: EmployeeDto
}

export function employeeControllerUpdate(http: HttpClient, rootUrl: string, params: EmployeeControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<EmployeeDto>> {
  const rb = new RequestBuilder(rootUrl, employeeControllerUpdate.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EmployeeDto>;
    })
  );
}

employeeControllerUpdate.PATH = '/api/employee';
